import { AudioTrackMenu } from "../../../components/menus/audio-track-menu.js";
import { CaptionsSubmenu } from "../../../components/menus/captions-submenu.js";
import { PlaybackRateSubmenu } from "../../../components/menus/playback-rate-submenu.js";
import { QualityMenu } from "../../../components/menus/quality-menu.js";
import { SettingsMenu } from "../../../components/menus/settings-menu.js";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/internal/skins/minimal-video/skins/shared/video/settings-menu.tsx
function VideoSettingsMenu(props = {}) {
	return /* @__PURE__ */ jsxs(SettingsMenu, {
		...props,
		children: [
			/* @__PURE__ */ jsx(QualityMenu, {}),
			/* @__PURE__ */ jsx(AudioTrackMenu, {}),
			/* @__PURE__ */ jsx(PlaybackRateSubmenu, {}),
			/* @__PURE__ */ jsx(CaptionsSubmenu, {})
		]
	});
}
//#endregion
export { VideoSettingsMenu };

//# sourceMappingURL=settings-menu.js.map